export default __webpack_public_path__ + "static/media/mastercard.46f644f3.svg";